import React from 'react';
import { Grid } from '@mui/material';
import Input from 'components/Input';
import Dropdown from 'components/Dropdown';
import InputMask from 'components/InputMask';
import VirtualDrop from 'components/VirtualDrop';

const Filter = ({ grid, control, drops }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('entidade') && (
        <Grid item xs={12}>
          <VirtualDrop
            name="entidade"
            control={control}
            label="Entidade"
            options={drops?.Entidade}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('dtvenc') && (
        <Grid item xs={6}>
          <InputMask
            name="dtvenc.i"
            control={control}
            label="Data de Vencimento Inicial"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('dtvenc') && (
        <Grid item xs={6}>
          <InputMask
            name="dtvenc.f"
            control={control}
            label="Data de Vencimento Final"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('valor') && (
        <Grid item xs={12}>
          <InputMask name="valor" control={control} label="Valor" />
        </Grid>
      )}
      {checkDisplay('vendedor') && (
        <Grid item xs={12}>
          <Dropdown
            name="vendedor"
            control={control}
            label="Vendedor"
            options={drops?.EntidadeTipo?.filter(
              (f) => f?.tipo === 'VENDEDOR' || f?.tipo === 'REPRESENTANTE'
            )}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('filial') && (
        <Grid item xs={12}>
          <Dropdown
            name="filial"
            control={control}
            label="Filial"
            options={drops?.Filial}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('dtemissao') && (
        <Grid item xs={6}>
          <InputMask
            name="dtemissao.i"
            control={control}
            label="Data de Emissão Inicial"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('dtemissao') && (
        <Grid item xs={6}>
          <InputMask
            name="dtemissao.f"
            control={control}
            label="Data de Emissão Final"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('observacao') && (
        <Grid item xs={12}>
          <Input name="observacao" control={control} label="Observação" />
        </Grid>
      )}
      {checkDisplay('banco') && (
        <Grid item xs={12}>
          <Dropdown
            name="banco"
            control={control}
            label="Banco"
            options={drops?.EntidadeTipo?.filter(
              (f) => f?.tipo === 'INSTITUICAO FINANCEIRA'
            )}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('agencia') && (
        <Grid item xs={12}>
          <Input name="agencia" control={control} label="Agência" />
        </Grid>
      )}
      {checkDisplay('conta') && (
        <Grid item xs={12}>
          <Input name="conta" control={control} label="Conta" />
        </Grid>
      )}
      {checkDisplay('cheque') && (
        <Grid item xs={12}>
          <Input name="cheque" control={control} label="Cheque" />
        </Grid>
      )}
      {checkDisplay('nome') && (
        <Grid item xs={12}>
          <Input name="nome" control={control} label="Nome" />
        </Grid>
      )}
      {checkDisplay('alinea') && (
        <Grid item xs={12}>
          <Dropdown
            name="alinea"
            control={control}
            label="Alinea"
            options={drops?.AlineaCheque}
            multiple
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
